// extracted by mini-css-extract-plugin
export var label = "_lm-2";
export var slideContainer = "_lm-0";
export var slider = "_lm-1";